import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/home/runner/work/wision/wision/apps/wision/src/layouts/admin.vue")),
  layout: defineAsyncComponent(() => import("/home/runner/work/wision/wision/apps/wision/src/layouts/layout.vue")),
  login: defineAsyncComponent(() => import("/home/runner/work/wision/wision/apps/wision/src/layouts/login.vue")),
  main: defineAsyncComponent(() => import("/home/runner/work/wision/wision/apps/wision/src/layouts/main.vue")),
  store: defineAsyncComponent(() => import("/home/runner/work/wision/wision/apps/wision/src/layouts/store.ts"))
}